import KeenSlider from 'keen-slider';

//Init carousel slider script
window.addEventListener('DOMContentLoaded', () => {

    function createSlider(wrapper) {
        new KeenSlider(wrapper.querySelector('.carousel-articles'), {
            selector: '.theme-dynamic-carousel__content__item',
            controls: true,
            loop: true,
            initial: 0,
            variableWidth: true,
            slides: {
                perView: 1,
                spacing: 0,
            },
            breakpoints: {
                '(min-width: 400px)': {
                    slides: {
                        perView: 2,
                        spacing: 16,
                    },
                },
                '(min-width: 960px)': {
                    slides: {
                        perView: 3,
                        spacing: 32,
                    },
                },
            },
            created: function (instance) {
                var dots_wrapper = wrapper.querySelector('.theme-dynamic-carousel_content__item--dots');
                var slides = wrapper.querySelectorAll('.theme-dynamic-carousel__content__item');
                slides.forEach(function (t, idx) {
                    var dot = document.createElement('div');
                    dot.classList.add('dot');
                    dots_wrapper.appendChild(dot);
                    dot.addEventListener('click', function () {
                        instance.moveToIdx(idx);
                    });
                });
                updateClasses(instance);
            },
            slideChanged(instance) {
                updateClasses(instance);
            },
        });

        function updateClasses(instance) {
            var slide = instance.track?.details?.rel ? instance.track.details.rel : 0;
            var dots = wrapper.querySelectorAll('.dot');
            dots.forEach(function (dot, idx) {
                idx === slide
                ? dot.classList.add('active')
                : dot.classList.remove('active');
            });
        }
    }

    document.querySelectorAll('.wrapper').forEach((wrapper) => {
        createSlider(wrapper);
    });
})
